import { render } from "./MenuPause.vue?vue&type=template&id=3eecb8ad"
import script from "./MenuPause.vue?vue&type=script&lang=js"
export * from "./MenuPause.vue?vue&type=script&lang=js"
script.render = render

export default script